import React from 'react'
import { CardPartial } from './CardPartial'
import { BusyButton } from '@ztechapps/webui.button'
import { useCheckoutContext } from '../../../index'
import { useStartCardPayment, useStartPartialCardPayment } from '../../../hooks/useStartCardPayment'
import { usePaymentMethodPanelContext } from '../Context'

export const Layout = () => {
  const context = useCheckoutContext()

  const [showLoadingOverlay] = context.showLoadingOverlay
  const { onStartPayment: onStartFullPayment, hasError } = useStartCardPayment()
  const { onStartPayment: onStartPartialPayment } = useStartPartialCardPayment()
  const { isPartial } = usePaymentMethodPanelContext()

  const onStartPayment = isPartial ? onStartPartialPayment : onStartFullPayment

  return (
    <React.Fragment>
      <ul>
        <li>
          <p>
            <b className={'text-primary'}>Cards (debit/credit)</b> - are one of the most popular ways to pay online,
            with broad global reach. We supports several card brands, from large global networks like Visa and
            Mastercard.
          </p>
        </li>
        <li>
          <p>
            <b className={'text-primary'}>Bank Debits</b> - ACH Direct Debit payments enables to pay by providing their
            bank account details. Customers must accept a mandate authorizing you to debit their account and verify
            ownership of the account through instant verification or micro-deposits.
          </p>
        </li>
        <li>
          <p>
            <b className={'text-primary'}>Bank Transfer</b> - Allow to pay directly from their bank accounts via bank
            transfer, with Stripe handling reconciliation and automated returns.
          </p>
        </li>
      </ul>

      <CardPartial />
      <br />
      <BusyButton
        bsStyle="primary"
        text={'Start payment'}
        isBusy={showLoadingOverlay}
        onClick={async () => {
          await onStartPayment()
        }}
        disabled={hasError}
      />
    </React.Fragment>
  )
}
